module.exports = "<div class=\"stat-legend\"></div><div class=\"stat-sequence\"></div><div class=\"stat-chart\"></div><div class=\"hideCaptions\"><i ng-click=\"$ctrl.hideCaptions()\" ng-if=\"$ctrl.showCaptions\" title=\"{{:: 'Скрыть названия' | gettext }}\" class=\"icon-hidden\"></i> <i ng-click=\"$ctrl.hideCaptions()\" ng-if=\"!$ctrl.showCaptions\" title=\"{{:: 'Показать названия' | gettext }}\" class=\"icon-privacy\"></i></div>"


//////////////////
// WEBPACK FOOTER
// ./src/stat/pie.component.html
// module id = 432
// module chunks = 0